export default __webpack_public_path__ + "static/media/abobora.717fc9d2.jpg";